import React, { Fragment, useState, useEffect } from 'react'
import Dialog from '../../../Components/Dialog'
import Button from '../../../Components/Button'
import history from '../../../History'
import './index.scss'
import Check from '../../../Utils/Check'
import FollowTips from '../FollowTips'
import e from '../../../Utils/Event'
import {riskManagement, getIdentifyCodeWithCaptcha} from '../../../Utils/Utils'

export default function BindTencentDialog(props) {
  let { visible, setVisible, initPhone, info, showphone } = props

  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');

  //绑定确认前弹窗
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [userPic, setUserPic] = useState('')
  const [userName, setUserName] = useState('名字来的')
  const [userStatusStr, setUserStatusStr] = useState('审核中，但是还没到审核中的到')
  const [reqId, setReqId] = useState('')
  const [role, setRole] = useState(1)
  const [roleStr, setRoleStr] = useState('类型')

  //提示弹窗
  const [showTipsDialog, setShowTipsDialog] = useState(false)
  const [title, setTitle] = useState('')
  const [btnFn, setBtnFn] = useState(null)
  const [tipsContent, setTipsContent] = useState('')
  const [hideClose, setHideClose] = useState(false)
  function showTips(title, word, btnFn, hideClose) {
    setTitle(title)
    setTipsContent(word)
    let fn = [{ text: '知道了', fn: () => {setShowTipsDialog(false);btnFn&&btnFn();} }];
    setBtnFn(btnFn || fn)
    setShowTipsDialog(true)
    setHideClose(hideClose)
  }

  function result(status, info){
    //对应BindTencentDialog中的状态
    let sucMap = [0,1,2,3,4,10,12,13,14,16,17,18,19,20,21,22,23,24,25,50];
    if (~sucMap.indexOf(status)) {
      showTips('换绑成功',`您已成功换绑酷狗id${window.$userInfo.userid}`, [{text: '好的', fn: () => {
        setShowTipsDialog(false);
        window.location.replace(window.location.protocol + '//' + window.location.host + window.location.pathname)
      }}], true)
    }else{
      showTips('换绑失败','失败原因，无法进行换绑', [{ text: '重新绑定', fn: () => {setShowTipsDialog(false)} }])
    }
  }

  //倒计时
  const [countNum, setCountNum] = useState(0)
  let timer = null;

  async function sendAuthCode() {
    if (countNum) return;
    if (!phone || !Check.phone(phone)) {
      return window.$Msg('请输入正确的手机号码')
    }

    try {
      const captchaParam = await getIdentifyCodeWithCaptcha();  // 发送验证码前调用这个方法
      console.log(captchaParam, 'captchaParam');
      countDown(60)
      window.$req('sendSmsCode', { 
        type: 0, 
        phone: '+86*' + phone, 
        singerId: info.singerId, 
        singerSource: info.source,
        platformAccountId: window.$userInfo.userid,
        platformIdType: 2,
        ticket: captchaParam.ticket,
        randstr: captchaParam.randstr
      }).then(res => {
        window.$Msg('发送成功')
      }).catch(rese=> {
        if(rese.code == "040030"){
          window.$Msg("您输入的手机号码与入驻音乐人号码不一致")
        }else if(rese.message) {
          window.$Msg(rese.message)
        }
      })
    } catch (error) {
      console.log(error, 'sendAuthCode Field error');
    }
  }

  function countDown(num) {
    setCountNum(num)
    if (!num) return;
    timer = setTimeout(() => {
      num--
      countDown(num)
    }, 1000)
  }

  function confirm() {
    if (!code) {
      return window.$Msg('请输入验证码')
    }
    let trimCode = code.trim()
    if (trimCode.length !== 6) {
      return window.$Msg('请输入6位验证码')
    }
    e.emit('loading', true)
    window.$req('bindPhoneBefore', {
      phone: '+86*' + phone,
      identifycode: code,
      platformAccountId: window.$userInfo.userid,
      platformIdType: 2
    }).then(res => {
      e.emit('loading', false)
      e.emit('bottomBind', false)
      if (res.code == 0) {
        let data = res.data
        if ( data.status === -1 || data.status === 51 ) {//已注销账号直接到结果页
          e.emit('loading', false)
          setConfirmVisible(false)
          result(data.status, data)
          return;
        }
        setReqId(data.reqId)
        setUserPic(data.pic)
        setUserName(data.userName)
        setUserStatusStr( data.status === 50 ? '当前还未实名认证，请补充资料' : data.statusStr )
        setRole(data.role)
        setRoleStr(data.roleStr)
        setVisible(false)
        setConfirmVisible(true)
      }
    }).catch(rese => {
      e.emit('loading', false)
      if((rese.errcode === 20028 || rese.errcode === 20029) && window.rejectRes) {//触发风控
        riskManagement(window.rejectRes);
        return;
      }
      let codeMap = [100004, 1000030, 1000031, 1000032]
      if (rese.code) {
        if (~codeMap.indexOf(Number(rese.code))) {
          //返回对应用户状态
          result(rese.code, { message: rese.message })
        } else {
          window.$Msg(rese.message)
        }
      } else {
        window.$Msg('服务异常，请稍后重试')
      }
    })
  }

  useEffect(() => {
    setPhone(initPhone || '')
    setCode('')
    return () => {
      clearTimeout(timer)
    }
  }, [timer, visible])

  return (<Fragment>

    <Dialog visible={visible} setVisible={setVisible} title="更换音乐人账号绑定ID" titleStyle={{ marginBottom: '0' }}>
      <div className="BindTencentDialog">
        <header>{showphone?`您入驻申请时填写的手机号码尾号为${showphone}`:''}<br/>请验证手机号后即可换绑</header>

        <Fragment>
          <section className="line">
            <input type="text" placeholder="请输入手机号" value={phone} onChange={e => setPhone(e.target.value)}></input>
          </section>
          <section className="line">
            <input type="text" placeholder="填入验证码" value={code} onChange={e => setCode(e.target.value)}></input>
            <div className={"send" + (countNum ? ' wait' : '')} onClick={sendAuthCode}>{countNum ? (countNum + 's') : '发送验证码'}</div>
          </section>

          <div className="confirm">
            <Button text="确认换绑" fn={confirm} />
            <p className="foget" onClick={()=>{
              history.go('/ChangeAccountInput/'+window.encodeURIComponent(JSON.stringify({singerId: info.singerId, singerSource: info.source})))
            }}>忘记手机号码 ></p>
          </div>
        </Fragment>

        <div className="follow">
          <FollowTips />
        </div>
      </div>
    </Dialog>


    <Dialog title={`类型：${roleStr}`} titleStyle={{ color: '#0090ff', marginBottom: '0.44rem', marginTop: '0.3rem', paddingLeft:'0.3rem', textAlign: 'left'}} visible={confirmVisible} setVisible={setConfirmVisible}>
      <div className="beforeBind">
        <section className="portrait">
          < img src={userPic || 'https://webimg.kgimg.com/770af1944474f8cc548d1a59723a54aa.png'} alt="" onError={e => {
            let target = e.target
            target.onerror = null;
            {/* target.src = 'https://webimg.kgimg.com/770af1944474f8cc548d1a59723a54aa.png' */}
          }} />
        </section>
        <section className="name">{userName}</section>
        <section className="desc">{userStatusStr}</section>

        <section className="btnGroup">
          <div className="left" onClick={e => {
            setConfirmVisible(false)
          }}>取消</div>
          <div className="right" onClick={oe => {
            e.emit('loading', true)
            window.pushBI({
              a: 22675,
              ft: '确认换绑按钮',
              r: '酷狗音乐开放平台'
            })
            window.$req('bindPhoneConfirm', {
              reqId,
              platformAccountId: window.$userInfo.userid,
              platformIdType: 2
            }).then(res => {
              e.emit('loading', false)
              if (res.code == 0) {
                window.$getUserStatus(({ status }, findItem) => {
                  e.emit('loading', false)
                  setConfirmVisible(false)
                  result(status, Object.assign({}, findItem || {}, { role }))
                  //showTips('换绑成功',`您已成功换绑酷狗id${window.$userInfo.userid}`, '好的')
                  //showTips('换绑失败','失败原因，无法进行换绑', '重新绑定')
                }, true)
              }
            }).catch(rese=> {
              e.emit('loading', false)
              setConfirmVisible(false)
              if((rese.errcode === 20028 || rese.errcode === 20029) && window.rejectRes) {//触发风控
                riskManagement(window.rejectRes);
                return;
              }
              window.$Msg(rese.msg || rese.message||'服务异常，请稍后重试')
            })
          }}>确认换绑</div>
        </section>
      </div>

    </Dialog>

    <Dialog title={title} visible={showTipsDialog} setVisible={setShowTipsDialog} btns={btnFn} hideClose={hideClose}>
      <div className="changeResult" >{tipsContent}</div>
    </Dialog>
  </Fragment>)
}